import _ from 'underscore';
import Backbone from 'backbone';
import { Dialog } from '@bingads-webui/dialog';
import { BaseFilterAgent } from './base-filter-agent';
import removeTmpl from './template/removeDialog.pug';

class RemoveDialog extends Backbone.View {
  initialize({ filterName, i18n }) {
    this.filterName = filterName;
    this.i18n = i18n;
  }
  render() {
    this.$el.html(removeTmpl({
      removeText: this.i18n.getString('FiltersMenu_PromptBeforeRemove').replace('{0}', this.filterName),
    }));
    return this;
  }
}

/**
 * Manage the creation/removal and show/hide of FilterEditor view<br>
 * Call FilterService to change filter state<br>
 * Set up a toolbar dropdown as filter menu<br>
 * @extends BaseFilterAgent
 * @fires FilterEditorAgent#filter-editor-shown
 */
export class FilterMenuAgent extends BaseFilterAgent {
  /**
   * Delete filter by name. UI will show a modal prompt to ask user for confirmation.
   * If user confirms, then call filter service to remove delete filter by name and
   * refresh filter menu once deletion is completed successfully
   * @private
   * @param {string} name - Filter name
   * @returns {undefined}
   */
  deleteByName(name) {
    this.options.filterService.getFilterByName(name).then((filter) => {
      const modalDialog = new Dialog({
        showHeader: false,
      }).setState({
        buttons: [{
          text: this.options.i18n.getString('Filter_Remove'),
          name: 'remove',
          class: 'btn-primary',
        }, {
          text: this.options.i18n.getString('Cancel'),
          name: 'cancel',
        }],
      }).setContent(new RemoveDialog({
        filterName: name,
        i18n: this.options.i18n,
      }))
        .render();

      this.options.toolbarView.view.$el.append(modalDialog.el);
      modalDialog.show();
      modalDialog.on('clickedButton', (buttonName) => {
        if (buttonName === 'remove') {
          this.options.filterService.deleteSavedFilter(filter).then(({ error }) => {
            if (!error) {
              this.trigger('filter-deleted-success');
              this.refresh();
            }
          });
        }

        modalDialog.remove();
      });
    });
  }

  /**
   * Apply named filter
   * @private
   * @returns {undefined}
   * @param {string} name - Filter name
   */
  applyByName(name) {
    this.options.filterService.setEditableFilterByName(name);
  }

  /**
   * Load saved filters from filter service and update filter menu accordingly
   * @returns {undefined}
   */
  refresh() {
    this.options.filterService.getSavedFilters().then((filterArray) => {
      const filterNames = _.pluck(filterArray, 'name');
      const menuItems = [{
        text: this.options.i18n.getString('Filter_Create_Filter'),
        onClick: () => this.trigger('create-new-filter'),
      }];

      if (this.options.menu && this.options.menu.customItems) {
        menuItems.push(...this.options.menu.customItems);
      }

      if (filterNames.length > 0) {
        menuItems.push({ type: 'dropdown-divider' });
        menuItems.push({
          type: 'dropdown-radio-group',
          id: 'dropdown-radio-group-saved-filters',
          title: this.options.i18n.getString('Filter_Apply_Saved_Filters'),
          items: _.map(filterNames, name => ({
            text: name,
            value: name,
          })),
          checkIcon: null,
          removeText: this.options.i18n.getString('Filter_Remove'),
          onSelect: this.applyByName.bind(this),
          onRemove: this.deleteByName.bind(this),
        });
      }
      const baseIconClass = ['glyphicon', 'toolbar-icon', 'toolbar-icon-left'];
      const newItem = {
        id: 'filter-menu',
        button: {
          text: this.options.i18n.getString('Filters'),
          iconLeft: baseIconClass.concat('icon-filter-normal'),
          iconRight: baseIconClass.concat('glyphicon-triangle-bottom'),
        },
        menu: {
          items: menuItems,
        },
      };

      if (this.options.toolbarView.rendered) {
        this.options.toolbarView.view.update(newItem);
      } else {
        this.options.toolbarView.once('rendered', () => {
          this.options.toolbarView.view.update(newItem);
        });
      }
    });
  }
}
